import "primereact/resources/themes/saga-orange/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";
import "css/global.css";
import NavBar from "components/NavBar/NavBar";
import { ChildrenContainer, MainContent } from "./styles";
import Footer from "../Footer/Footer";
import { Helmet } from "react-helmet";
import { useI18next } from "gatsby-plugin-react-i18next";
import { useMemo } from "react";

const Layout = ({ children, hasPadding = true, title }) => {
  const { language } = useI18next();
  const htmlAttributes = useMemo(
    () => ({
      lang: language,
    }),
    [language]
  );

  return (
    <>
      <Helmet htmlAttributes={htmlAttributes}>
        {title && <title>{title}</title>}
      </Helmet>
      <MainContent>
        <NavBar shadowed />
        <ChildrenContainer hasPadding={hasPadding}>
          {children}
        </ChildrenContainer>
      </MainContent>
      <Footer />
    </>
  );
};

export default Layout;
